export default __webpack_public_path__ + "static/media/pencil.ed3b8d97.svg";